import { RecruitingInterviewStatics } from '../../../../../../../store/workspace/types';
import MotionWrapper from '../../../../../../../layouts/MotionWrapper';
import { useDispatch } from '../../../../../../../store/store';
import Button from '../../../../../../../components/Button';
import Accordion, { accordionActionClassName } from '../../../../components/Accordion';
import ResultIcon from '../../../../components/ResultIcon';
import EmptyState from '../../../../components/EmptyState';
import { RECRUITING_INTERVIEW_CRITERIA } from '../../../../constants';
import { useAccordions } from '../../../../hooks/useAccordions';
import styles from './style.module.scss';
import {
    setVideoSrc,
    setVideoSubtitleSrc,
    setVideoPlayerModal,
} from '../../../../../../../store/workspace/slice';

interface Props {
    applicantId: string | undefined;
    interviewData: RecruitingInterviewStatics | null;
};

export default function RecruitingInterviewResults(props: Props) {
    const { applicantId, interviewData } = props;

    const dispatch = useDispatch();
    const { isOpen, toggle } = useAccordions();
    const applicant = interviewData?.examiners.find(item => item.userId === applicantId);

    const criteriaOf = (key: string) =>
        applicant?.evaluatedCriteria?.find(item => item.nameKey === key);

    const openVideoPlayer = (src: string, subtitle: string) => {
        dispatch(setVideoSrc(src));
        dispatch(setVideoSubtitleSrc(subtitle));
        dispatch(setVideoPlayerModal(true));
    };

    if (!applicant) {
        return (
            <MotionWrapper className={styles.container}>
                <EmptyState className={styles.empty_state} />
            </MotionWrapper>
        );
    }

    return (
        <MotionWrapper className={styles.container}>
            <div className={styles.main}>
                <div className={styles.header}>
                    <span className={styles.header_item}>
                        Applicant name : {applicant.first_name} {applicant.last_name}
                    </span>
                    <span className={styles.header_item}>
                        Question quantities : {interviewData?.exam.countQuestions}
                    </span>
                    <span className={styles.header_item}>
                        Interview time : {(interviewData?.exam.countQuestions || 0) * 5}’
                    </span>
                </div>

                <div className={styles.question_data}>
                    <table>
                        <thead>
                            <tr>
                                {RECRUITING_INTERVIEW_CRITERIA.map(criteria => <th key={criteria.key}>
                                    {criteria.title}
                                </th>)}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                {RECRUITING_INTERVIEW_CRITERIA.map(criteria => {
                                    const matched = criteriaOf(criteria.key);
                                    return <td key={criteria.key}>
                                        {matched ? <ResultIcon result={matched.result} /> : 'N/A'}
                                    </td>;
                                })}
                            </tr>
                        </tbody>
                    </table>

                    <div className={styles.card}>
                        <div className={styles.card_body}>
                            <div className={styles.card_body_section}>
                                <div className={styles.card_body_section_title}>
                                    Criteria
                                </div>
                                <div className={styles.card_body_section_content}>
                                    {RECRUITING_INTERVIEW_CRITERIA.map(criteria => <div
                                        key={criteria.key}
                                        className={styles.card_body_section_content_item}
                                    >
                                        <span>{criteria.title}</span>
                                        <div className={styles.card_body_section_content_item_result}>
                                            <ResultIcon result={criteriaOf(criteria.key)?.result || 'Not Applicable'} />
                                            <span>Report</span>
                                        </div>
                                    </div>)}
                                </div>
                            </div>
                        </div>
                    </div>

                    {applicant.answerAnalysis?.map((analysis, index) => <div className={styles.section} key={index}>
                        <div className={styles.section_question}>
                            <span>Question {index + 1}:</span>
                            <span>{interviewData?.exam.questions[index].question}</span>
                        </div>

                        <Accordion
                            preformatted
                            title='Summary'
                            open={isOpen(`summary-${index}`)}
                            onToggle={() => toggle(`summary-${index}`)}
                        >
                            {analysis.summary}
                        </Accordion>

                        <Accordion
                            preformatted
                            title='Feedback'
                            open={isOpen(`feedback-${index}`)}
                            onToggle={() => toggle(`feedback-${index}`)}
                        >
                            {analysis.feedback}
                        </Accordion>

                        <Accordion
                            title='Applicant Video:'
                            action={<Button
                                type='Primary'
                                text='Open Player'
                                className={accordionActionClassName}
                                onClick={() => openVideoPlayer(analysis.file, analysis.subtitle)}
                            />}
                        />
                    </div>)}
                </div>
            </div>
        </MotionWrapper>
    );
};
